module.exports = __webpack_public_path__ + "static/media/15.664d1404.jpg";